import {
  MegaMenuVariants,
  Section,
  SideNavigationDropdown,
  Spacer,
  Spacings,
  useMediaQuery
} from '@polestar/component-warehouse-react';
import { LoggedinSideNavigation } from '@polestar/loggedin-core';
import { Page, useMarket } from '@polestar/shared-front-myorder';
import type { ReactNode } from 'react';
import { useMatch } from 'react-router';
import { config } from '~root/src/config';
import { useMenuItems } from '../../hooks/useMenuItems';
import { useTranslation } from '../../hooks/useQueryDatoContent';

type AppPageProps = {
  children: ReactNode;
  hideSideNavigation: boolean;
};

export const AppPage = ({ children, hideSideNavigation }: AppPageProps) => {
  const { currentMarket } = useMarket();
  const { menuItems } = useMenuItems();
  const { name } = useMediaQuery();
  const text = useTranslation();
  const isDeliveredRoute = useMatch('/:locale/:namespace/:orderId/delivered');
  const isExtrasRoute = useMatch('/:locale/:namespace/:orderId/extras');

  const isTabletOrMobile = name === 'mobile' || name === 'tablet';
  const showSubMenu = menuItems.length > 0 && !isDeliveredRoute && !isExtrasRoute;
  const showDivider = Boolean(!isTabletOrMobile || isDeliveredRoute || isExtrasRoute);

  const subNavigationData = showSubMenu
    ? [
        {
          id: 'loggedin-navigation',
          bleed: true,
          node: (
            <SideNavigationDropdown
              items={menuItems}
              aria-label={text('Side Navigation Dropdown')}
            />
          )
        }
      ]
    : undefined;

  return (
    <Page
      datoToken={config.dato.token}
      showSupportDrawerNew={config.feature.showNewSupportDrawer}
      supportDrawerNewProps={{
        environment: config.stage,
        isSupportButtonVisible: config.feature.showNewSupportDrawer
      }}
      megaMenuProps={{
        currentLocation: currentMarket?.locale,
        variant: MegaMenuVariants.stickySubNavigation,
        subNavigation: subNavigationData,
        divider: showDivider
      }}
      hideMarketSelector
    >
      <Spacer spacing={Spacings.medium} />
      {hideSideNavigation ? (
        <Section>{children}</Section>
      ) : (
        <LoggedinSideNavigation menuItems={menuItems}>{children}</LoggedinSideNavigation>
      )}
    </Page>
  );
};
